<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable max-len -->
<template lang="pug">
footer.footer.d-flex.justify-content-around.mt-4.flex-row.py-4
  .left-side.d-flex.flex-row
    a.ms-2(href='/PoliticadePrivacidade.pdf', target='_blank') Política de privacidade
    span.ms-2 |
    a.link.ms-2(href='/PoliticadeCookies.pdf', target='_blank') Política de cookies
  .right-side.d-flex.justify-content-center.align-items-center
    span.me-4 2010-{{ currentYear }} © SOLUTI Certificação Digital
    VersionButton
</template>

<script lang="ts">
  import Icon from '@/components/Atoms/Icon.vue'
  import { defineComponent } from 'vue'
  import VersionButton from './VersionButton.vue'
  import config from '../../../config'

  export default defineComponent({
    name: 'FooterComponent',
    url: config,
    components: {
      Icon,
      VersionButton,
    },
    computed: {
      currentYear() {
        const currentDate = new Date()
        return currentDate.getFullYear()
      },
    },
  })
</script>

<style lang="stylus" scoped>
  footer
    color: #343A40
    bottom: 0
    width: 100%
    // position: absolute
    background-color: #FCFCFC
    border-top: 1px solid #E6E7EC;
    font-size: 0.875rem;
    min-height: 56px
    .left-side
      font-weight: 600
      a
        color: #343A40

  @media screen and (max-width: 1424px)
    footer
      position: relative

  @media screen and (max-width: 831px)
    footer
      font-weight: 500
      display: flex
      flex-direction: column !important
      justify-content: center
      font-size: 0.75rem
      .left-side
        display: flex
        flex-direction: column !important
        justify-content: space-around
        a
          text-decoration: underline
          margin: 0 .5rem .5rem 0rem
        span
          display: none
</style>
